import I18n from 'I18n';
const isDatasetMeasure = item => 'field' in item.value;
const getHelpText = item => {
  if (item.errorMessage) {
    return I18n.text('report-customization-components.customization-components.relational-report.default-measures-help');
  }
  return undefined;
};
export const createDatasetPropertyGroup = ({
  items,
  heading
}) => {
  if (!items || items.size === 0) {
    return null;
  }
  return {
    text: heading.text,
    value: heading.text,
    options: items.map(item => {
      const isMeasure = isDatasetMeasure(item);
      return {
        text: item.text,
        value: isMeasure ? `${item.value.field.table}.${item.value.field.name}` : `${item.value.table}.${item.value.name}`,
        disabled: isMeasure ? false : Boolean(item.errorMessage),
        help: isMeasure ? undefined : getHelpText(item)
      };
    }).toJS()
  };
};